import * as React from 'react'
export const Ar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h512v342H0z" />
    <path fill="#338AF3" d="M0 0h512v114H0zm0 228h512v114H0z" />
    <circle cx={256.5} cy={171} r={40} fill="#FFDA44" stroke="#d6ab00" strokeWidth={5} />
  </svg>
)
